/* ==================================================================
   North Shore Peptides — FAQ accordion
   Optional single-open behavior. Native <details> works without JS.
   ================================================================== */
(function () {
  'use strict';

  function initFaq(root) {
    if (!root || root.dataset.npInit === 'true') return;
    root.dataset.npInit = 'true';

    if (root.dataset.singleOpen !== 'true') return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.np-faq__item'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.np-faq').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-faq');
    if (el) { el.dataset.npInit = ''; initFaq(el); }
  });
})();
